// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file service/admin/crud/result_crud_service_generated.proto (package service, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Result } from "../../../entity/result_pb";

/**
 * IndexResultArgs メッセージ
 *
 * @generated from message service.IndexResultArgs
 */
export class IndexResultArgs extends Message<IndexResultArgs> {
  /**
   * @generated from field: int32 offset = 1;
   */
  offset = 0;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  constructor(data?: PartialMessage<IndexResultArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.IndexResultArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "offset", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IndexResultArgs {
    return new IndexResultArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IndexResultArgs {
    return new IndexResultArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IndexResultArgs {
    return new IndexResultArgs().fromJsonString(jsonString, options);
  }

  static equals(a: IndexResultArgs | PlainMessage<IndexResultArgs> | undefined, b: IndexResultArgs | PlainMessage<IndexResultArgs> | undefined): boolean {
    return proto3.util.equals(IndexResultArgs, a, b);
  }
}

/**
 * CreateResultArgs メッセージ
 *
 * @generated from message service.CreateResultArgs
 */
export class CreateResultArgs extends Message<CreateResultArgs> {
  /**
   * @generated from field: repeated entity.Result results = 1;
   */
  results: Result[] = [];

  /**
   * @generated from field: bool force_execute = 2 [json_name = "force_execute"];
   */
  forceExecute = false;

  /**
   * @generated from field: bool skip_version_migration = 3 [json_name = "skip_version_migration"];
   */
  skipVersionMigration = false;

  constructor(data?: PartialMessage<CreateResultArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.CreateResultArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "results", kind: "message", T: Result, repeated: true },
    { no: 2, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "skip_version_migration", jsonName: "skip_version_migration", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateResultArgs {
    return new CreateResultArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateResultArgs {
    return new CreateResultArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateResultArgs {
    return new CreateResultArgs().fromJsonString(jsonString, options);
  }

  static equals(a: CreateResultArgs | PlainMessage<CreateResultArgs> | undefined, b: CreateResultArgs | PlainMessage<CreateResultArgs> | undefined): boolean {
    return proto3.util.equals(CreateResultArgs, a, b);
  }
}

/**
 * ReadResultArgs メッセージ
 *
 * @generated from message service.ReadResultArgs
 */
export class ReadResultArgs extends Message<ReadResultArgs> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  constructor(data?: PartialMessage<ReadResultArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.ReadResultArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadResultArgs {
    return new ReadResultArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadResultArgs {
    return new ReadResultArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadResultArgs {
    return new ReadResultArgs().fromJsonString(jsonString, options);
  }

  static equals(a: ReadResultArgs | PlainMessage<ReadResultArgs> | undefined, b: ReadResultArgs | PlainMessage<ReadResultArgs> | undefined): boolean {
    return proto3.util.equals(ReadResultArgs, a, b);
  }
}

/**
 * UpdateResultArgs メッセージ
 *
 * @generated from message service.UpdateResultArgs
 */
export class UpdateResultArgs extends Message<UpdateResultArgs> {
  /**
   * @generated from field: repeated entity.Result results = 1;
   */
  results: Result[] = [];

  /**
   * @generated from field: bool allow_missing = 2 [json_name = "allow_missing"];
   */
  allowMissing = false;

  /**
   * @generated from field: bool force_execute = 3 [json_name = "force_execute"];
   */
  forceExecute = false;

  /**
   * @generated from field: bool skip_version_migration = 4 [json_name = "skip_version_migration"];
   */
  skipVersionMigration = false;

  constructor(data?: PartialMessage<UpdateResultArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UpdateResultArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "results", kind: "message", T: Result, repeated: true },
    { no: 2, name: "allow_missing", jsonName: "allow_missing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "skip_version_migration", jsonName: "skip_version_migration", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateResultArgs {
    return new UpdateResultArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateResultArgs {
    return new UpdateResultArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateResultArgs {
    return new UpdateResultArgs().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateResultArgs | PlainMessage<UpdateResultArgs> | undefined, b: UpdateResultArgs | PlainMessage<UpdateResultArgs> | undefined): boolean {
    return proto3.util.equals(UpdateResultArgs, a, b);
  }
}

/**
 * DeleteResultArgs メッセージ
 *
 * @generated from message service.DeleteResultArgs
 */
export class DeleteResultArgs extends Message<DeleteResultArgs> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  /**
   * @generated from field: bool force_execute = 2 [json_name = "force_execute"];
   */
  forceExecute = false;

  constructor(data?: PartialMessage<DeleteResultArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteResultArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteResultArgs {
    return new DeleteResultArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteResultArgs {
    return new DeleteResultArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteResultArgs {
    return new DeleteResultArgs().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteResultArgs | PlainMessage<DeleteResultArgs> | undefined, b: DeleteResultArgs | PlainMessage<DeleteResultArgs> | undefined): boolean {
    return proto3.util.equals(DeleteResultArgs, a, b);
  }
}

/**
 * IndexResultReply メッセージ
 *
 * @generated from message service.IndexResultReply
 */
export class IndexResultReply extends Message<IndexResultReply> {
  /**
   * @generated from field: repeated entity.Result results = 1;
   */
  results: Result[] = [];

  constructor(data?: PartialMessage<IndexResultReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.IndexResultReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "results", kind: "message", T: Result, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IndexResultReply {
    return new IndexResultReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IndexResultReply {
    return new IndexResultReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IndexResultReply {
    return new IndexResultReply().fromJsonString(jsonString, options);
  }

  static equals(a: IndexResultReply | PlainMessage<IndexResultReply> | undefined, b: IndexResultReply | PlainMessage<IndexResultReply> | undefined): boolean {
    return proto3.util.equals(IndexResultReply, a, b);
  }
}

/**
 * CreateResultReply メッセージ
 *
 * @generated from message service.CreateResultReply
 */
export class CreateResultReply extends Message<CreateResultReply> {
  constructor(data?: PartialMessage<CreateResultReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.CreateResultReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateResultReply {
    return new CreateResultReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateResultReply {
    return new CreateResultReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateResultReply {
    return new CreateResultReply().fromJsonString(jsonString, options);
  }

  static equals(a: CreateResultReply | PlainMessage<CreateResultReply> | undefined, b: CreateResultReply | PlainMessage<CreateResultReply> | undefined): boolean {
    return proto3.util.equals(CreateResultReply, a, b);
  }
}

/**
 * ReadResultReply メッセージ
 *
 * @generated from message service.ReadResultReply
 */
export class ReadResultReply extends Message<ReadResultReply> {
  /**
   * @generated from field: repeated entity.Result results = 1;
   */
  results: Result[] = [];

  constructor(data?: PartialMessage<ReadResultReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.ReadResultReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "results", kind: "message", T: Result, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadResultReply {
    return new ReadResultReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadResultReply {
    return new ReadResultReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadResultReply {
    return new ReadResultReply().fromJsonString(jsonString, options);
  }

  static equals(a: ReadResultReply | PlainMessage<ReadResultReply> | undefined, b: ReadResultReply | PlainMessage<ReadResultReply> | undefined): boolean {
    return proto3.util.equals(ReadResultReply, a, b);
  }
}

/**
 * UpdateResultReply メッセージ
 *
 * @generated from message service.UpdateResultReply
 */
export class UpdateResultReply extends Message<UpdateResultReply> {
  constructor(data?: PartialMessage<UpdateResultReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UpdateResultReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateResultReply {
    return new UpdateResultReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateResultReply {
    return new UpdateResultReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateResultReply {
    return new UpdateResultReply().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateResultReply | PlainMessage<UpdateResultReply> | undefined, b: UpdateResultReply | PlainMessage<UpdateResultReply> | undefined): boolean {
    return proto3.util.equals(UpdateResultReply, a, b);
  }
}

/**
 * DeleteResultReply メッセージ
 *
 * @generated from message service.DeleteResultReply
 */
export class DeleteResultReply extends Message<DeleteResultReply> {
  constructor(data?: PartialMessage<DeleteResultReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteResultReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteResultReply {
    return new DeleteResultReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteResultReply {
    return new DeleteResultReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteResultReply {
    return new DeleteResultReply().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteResultReply | PlainMessage<DeleteResultReply> | undefined, b: DeleteResultReply | PlainMessage<DeleteResultReply> | undefined): boolean {
    return proto3.util.equals(DeleteResultReply, a, b);
  }
}

